<div class="container-fluid" >
    <div class="row">
        <div class="col-9 m-auto">
            <div class="card p-4">
                <div class="card-body">
                    <form novalidate="">
                        <div class="custom-form ">
                            <div class="row">
                                <div *ngIf="decsionObject" class="col-lg-12" style="margin: auto;">
                                    <div class="form-group col-lg-12 mt-3">
                                        <label>{{ "DecsionObjection" | translate }}</label>
                                        <span class="form-control" readonly>{{decsionObject.objectionDecsion}} &nbsp;</span>
                                    </div>
                                    <div class="form-group col-lg-12 mt-3">
                                        <label>{{ "StudyObjection" | translate }}</label>
                                        <span class="form-control" readonly>{{decsionObject.studyResult}} &nbsp;</span>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>